<template>
  <div class="pdf-viewer" v-if="src">
    <div class="pdf-bar">
      <div class="zoom-minus" @click="zoomMinus">
        <i class="el-icon-minus" title="缩小"></i>
      </div>
      <div class="scale">
        <el-input v-model.number="scale" size="mini" @blur="applyScale">
          <template slot="append">%</template>
        </el-input>
      </div>
      <div class="zoom-plus" @click="zoomPlus">
        <i class="el-icon-plus" title="放大"></i>
      </div>
      <div class="prev" @click="prePage">上一页</div>
      <div class="page">
        <el-input-number v-model.number="page" :min="1" :max="pageCount" size="mini" />
      </div>
      <div class="page-count">/ {{ pageCount }}</div>
      <div class="next" @click="nextPage">下一页</div>
    </div>

    <div class="pdf-wrapper" ref="pdfWrapper">
      <div
        :style="{ width: scale + '%', margin: '0 auto' }"
      >
        <vue-office-pdf
          :src="src"
          :options="pdfOptions"
          @rendered="onRendered"
          @error="onError"
        />
      </div>
    </div>

    <div
      class="font18 fontWeight loading-tip"
      v-if="showLoading"
    >加载中...</div>
  </div>
</template>

<script>
import VueOfficePdf from '@vue-office/pdf'

export default {
  components: { VueOfficePdf },
  props: {
    src: String,
    startPage: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      scale: 100,
      showLoading: true
    }
  },
  computed: {
    pdfOptions() {
      return {
        currentPage: this.page
      }
    }
  },
  watch: {
    src() {
      this.page = this.startPage || 1
      this.showLoading = true
    }
  },
  methods: {
    onRendered(e) {
      this.showLoading = false
      // @vue-office/pdf rendered 事件携带总页数
      if (e && e.total) {
        this.pageCount = e.total
      }
    },
    onError(err) {
      this.showLoading = false
      console.error('PDF 加载失败：', err)
      this.$message && this.$message.error('PDF 加载失败，请检查文件地址')
    },
    applyScale(e) {
      const val = Number(e.target.value)
      if (isNaN(val)) return
      this.scale = Math.min(200, Math.max(20, val))
    },
    zoomMinus() {
      if (this.scale > 20) this.scale = Math.max(20, this.scale - 5)
    },
    zoomPlus() {
      if (this.scale < 200) this.scale = Math.min(200, this.scale + 5)
    },
    prePage() {
      if (this.page > 1) this.page -= 1
    },
    nextPage() {
      if (this.page < this.pageCount) this.page += 1
    }
  }
}
</script>

<style lang="scss" scoped>
.pdf-viewer {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .pdf-bar {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 50px;
    border: 1px solid #ddd;
    box-sizing: border-box;
    text-align: center;
    background: #f8f8f8;
    display: flex;
    justify-content: center;
    align-items: center;

    & > div {
      min-width: 36px;
      height: 36px;
      line-height: 36px;
      color: #666;
      cursor: pointer;

      i {
        width: 100%;
        height: 100%;
        color: #666;
        font-weight: bold;
      }

      ::v-deep .el-input--mini {
        input {
          padding: 0 8px;
          width: 50px;
          text-align: center;
        }
        .el-input-group__append {
          padding: 0 6px;
          color: #666;
          cursor: auto;
        }
      }

      ::v-deep .el-input-number {
        margin-left: 10px;
        width: 40px;
        .el-input-number__decrease,
        .el-input-number__increase { display: none; }
        .el-input--mini input {
          width: 40px;
          text-align: center;
        }
      }
    }

    .prev { margin-left: 16px; }
    .scale, .page { display: flex; align-items: center; }
    .page-count { margin-right: 10px; }
  }

  .pdf-wrapper {
    position: absolute;
    margin-top: 50px;
    width: 100%;
    height: calc(100% - 50px);
    overflow: auto;
  }

  .loading-tip {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
